type SvgProps = React.SVGProps<SVGSVGElement>;

export function IconKeyboardDel(props: SvgProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <g clipPath="url(#clip0_1555_1655)">
        <path
          d="M18.9995 3C20.5971 3 21.9032 4.24892 21.9944 5.82373L21.9995 6V18C21.9995 19.5977 20.7505 20.9037 19.1758 20.9949L18.9995 21H8.10796C7.13824 21 6.23264 20.5316 5.67151 19.7504L5.56396 19.59L1.48271 13.06C1.10855 12.4614 1.07978 11.7141 1.39637 11.0926L1.48271 10.94L5.56396 4.41C6.07792 3.58768 6.95503 3.06795 7.91496 3.0062L8.10796 3H18.9995ZM18.9995 5H8.10796C7.80627 5 7.5232 5.13599 7.33472 5.36586L7.25996 5.47L3.17871 12L7.25996 18.53C7.41986 18.7859 7.68521 18.9538 7.98003 18.9918L8.10796 19H18.9995C19.5123 19 19.935 18.614 19.9928 18.1166L19.9995 18V6C19.9995 5.48717 19.6134 5.06449 19.1161 5.00673L18.9995 5ZM10.8781 8.46447L12.9994 10.5858L15.1208 8.46447C15.5113 8.07394 16.1445 8.07394 16.535 8.46447C16.9255 8.85499 16.9255 9.48815 16.535 9.87868L14.4137 12L16.535 14.1213C16.9255 14.5118 16.9255 15.145 16.535 15.5355C16.1445 15.9261 15.5113 15.9261 15.1208 15.5355L12.9994 13.4142L10.8781 15.5355C10.4876 15.9261 9.85444 15.9261 9.46392 15.5355C9.0734 15.145 9.0734 14.5118 9.46392 14.1213L11.5852 12L9.46392 9.87868C9.0734 9.48815 9.0734 8.85499 9.46392 8.46447C9.85444 8.07394 10.4876 8.07394 10.8781 8.46447Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_1555_1655">
          <rect width={24} height={24} fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
